module.exports = __webpack_public_path__ + "static/media/0010_IMG_LA_COQUE.c8079b53.webp";